module.exports = __webpack_public_path__ + "static/img/icon-2.b58362b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/icon-2.png
// module id = Oxyt
// module chunks = 0